import { render, staticRenderFns } from "./资料下载.vue?vue&type=template&id=1aab5c0c&scoped=true"
import script from "./资料下载.vue?vue&type=script&lang=js"
export * from "./资料下载.vue?vue&type=script&lang=js"
import style0 from "./资料下载.vue?vue&type=style&index=0&id=1aab5c0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aab5c0c",
  null
  
)

export default component.exports